module.exports = __webpack_public_path__ + "static/img/irole.cfc08ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/ch/irole.png
// module id = AZdE
// module chunks = 7